import { TenantsPreviewResponseModel } from '../models/userModel';

export const TenantsPreviewEntity = ({ isError, previewData }: TenantsPreviewResponseModel): Readonly<TenantsPreviewResponseModel> => {
  return Object.freeze({ isError, previewData });
};
